import { defineMessages } from "react-intl";

export const messages = defineMessages({
  allCountriesOption: {
    id: "ads_manager.geo_targeting.option.all_countries",
    defaultMessage: "All",
    description: "Option label for targeting all available countries.",
  },
  allCountriesTrigger: {
    id: "ads_manager.geo_targeting.trigger.all_countries",
    defaultMessage: "All countries",
    description: "Selector summary when all available countries are targeted.",
  },
  selectPlaceholder: {
    id: "ads_manager.geo_targeting.trigger.select",
    defaultMessage: "Select...",
    description: "Placeholder when no targeting country is selected.",
  },
  countriesSelected: {
    id: "ads_manager.geo_targeting.trigger.countries_selected",
    defaultMessage: "{count, plural, one {# country selected} other {# countries selected}}",
    description: "Selector summary for multiple targeted countries.",
  },
  locationsSelected: {
    id: "ads_manager.geo_targeting.trigger.locations_selected",
    defaultMessage: "{count, plural, one {# location selected} other {# locations selected}}",
    description: "Selector summary for multiple targeted geographic locations.",
  },
  enterLocationPlaceholder: {
    id: "ads_manager.geo_targeting.trigger.enter_location",
    defaultMessage: "Enter a location to include",
    description: "Placeholder when no geographic location is selected.",
  },
  loadingLocations: {
    id: "ads_manager.geo_targeting.search.loading",
    defaultMessage: "Loading",
    description: "Status shown while campaign location search results are loading.",
  },
  locationNotAvailable: {
    id: "ads_manager.geo_targeting.search.disabled_location",
    defaultMessage: "This region is not yet available for targeting.",
    description: "Explains why a country or region is disabled for targeting.",
  },
  removeLocationLabel: {
    id: "ads_manager.geo_targeting.button.remove_location",
    defaultMessage: "Remove {location}",
    description: "Accessible label for removing a targeted geographic location.",
  },
  cityLabel: {
    id: "ads_manager.geo_targeting.location_type.city",
    defaultMessage: "City",
    description: "Location-type badge for a city.",
  },
  countryLabel: {
    id: "ads_manager.geo_targeting.location_type.country",
    defaultMessage: "Country",
    description: "Location-type badge for a country.",
  },
  countyLabel: {
    id: "ads_manager.geo_targeting.location_type.county",
    defaultMessage: "County",
    description: "Location-type badge for a county.",
  },
  dmaLabel: {
    id: "ads_manager.geo_targeting.location_type.dma",
    defaultMessage: "DMA",
    description: "Location-type badge for a designated market area.",
  },
  postalCodeLabel: {
    id: "ads_manager.geo_targeting.location_type.postal_code",
    defaultMessage: "Postal code",
    description: "Location-type badge for a postal code.",
  },
  regionsLabel: {
    id: "ads_manager.geo_targeting.location_type.region",
    defaultMessage: "Regions",
    description: "Location-type badge for a region.",
  },
});
